import {
  FaTachometerAlt,
  FaCheck,
  FaCheckDouble,
  FaExchangeAlt,
  FaChartBar,
  FaBan,
  FaFileAlt,
  FaPlus,
  FaTasks,
  FaCalendarAlt,
  FaChartLine,
  FaAlignJustify,
  FaTools,
  FaEdit,
  FaLaptop,
  FaDollarSign,  
  FaClipboard,
  FaClipboardList,
  FaClipboardCheck,
  FaDesktop,
  FaBuffer,
  FaCheckCircle,
  FaUsers
} from "react-icons/fa";

// Centralized config for mobile menu sections and items
export const menuSections = [
  {
    id: "general",
    title: "General",
    gridClass: "grid grid-cols-2 gap-1",
    items: [
      {
        id: "dashboard",
        title: "Dashboard",
        href: "/dashboard",
        Icon: FaTachometerAlt,
        bgClass: "bg-customFontGreen",
        description: "Dashboard"
      },
      {
        id: "check-odd",
        title: "Check Odd",
        href: "/check-odd",
        Icon: FaCheck,
        bgClass: "bg-background",
        description: "Odds check from Rapid"
      },
      {
        id: "different-odd",
        title: "Different Odd",
        href: "/diff-odd",
        Icon: FaTasks,
        bgClass: "bg-customFontGold",
        description: "Different odds with 555mix"
      },
      {
        id: "match-event",
        title: "Match Event",
        href: "/match-event",
        Icon: FaExchangeAlt,
        bgClass: "bg-customFontVoilet",
        spanClass: "",
        description: "Matching with 555mix"
      },
        {
        id: "odds-hub",
        title: "Odds Hub",
        href: "/odds-hub",
        Icon: FaAlignJustify,
        bgClass: "bg-customFontVoilet",
        spanClass: "",
        description: "Raw odds data list"
      }
    ],
  },
  {
    id: "result",
    title: "Result",
    gridClass: "grid grid-cols-2 gap-1",
    items: [
      {
        id: "result-list",
        title: "Result Hub",
        href: "/result-hub",
        Icon: FaAlignJustify,
        bgClass: "bg-customRiver",
        description: "Raw result data list"
      },
      {
        id: "insert-result",
        title: "Insert Result",
        href: "/insert-result",
        Icon: FaPlus,
        bgClass: "bg-yellow-800",
        spanClass: "",
        description: "Result insertion"
      },
      {
        id: "recalculation",
        title: "Recalculation",
        href: "/update-result",
        Icon: FaEdit,
        bgClass: "bg-customLightYellow",
        spanClass: "",
        description: "Recalculate vouchers"
      },
    ],
  },
  {
    id: "report",
    title: "Report",
    gridClass: "grid grid-cols-2 gap-1",
    items: [
      {
        id: "report-byevent",
        title: "By Event",
        href: "/report-byevent",
        Icon: FaClipboard,
        bgClass: "bg-customTurquosie",
        description: "Event risk report"
      },
      {
        id: "report-bymix",
        title: "By Mix",
        href: "/report-bymix",
        Icon: FaClipboardList,
        bgClass: "bg-customFlicker",
        description: "Mix risk report"
      },
      {
        id: "report-bypurchased",
        title: "By Purchased",
        href: "/report-bypurchased",
        Icon: FaClipboardCheck,
        bgClass: "bg-primary",
        description: "Purchased vouchers"
      },
      {
        id: "win-lose",
        title: "Win Lose",
        href: "/win-lose",
        Icon: FaChartBar,
        bgClass: "bg-red-500",
        description: "Win lose report v2"
      },
    ],
  },
  {
    id: "transaction",
    title: "Transaction",
    gridClass: "grid grid-cols-2 gap-1 w-full",
    items: [
      {
        id: "transaction-bydate",
        title: "User Transaction",
        href: "/transaction-bydate",
        Icon: FaCalendarAlt,
        bgClass: "bg-customPredawn",
        spanClass: "",
        description: "Search transaction by date"
      },
      {
        id: "balance-transaction",
        title: "Balance Transaction",
        href: "/balance-transfer",
        Icon: FaDollarSign ,
        bgClass: "bg-customPredawn",
        spanClass: "",
        description: "User balance transfer"
      },
    ]
  },
  {
    id: "authority",
    title: "Admin Authority",
    gridClass: "grid grid-cols-2 gap-1 w-full",
    items: [
      {
        id: "by-voucher",
        title: "By Voucher",
        href: "/by-voucher",
        Icon: FaFileAlt,
        bgClass: "bg-customAltas",
        spanClass: "",
        description: "Search by voucher no"
      },
      {
        id: "live-event-control",
        title: "Event Control",
        href: "/live-event-control",
        Icon: FaLaptop,
        bgClass: "bg-customPredawn",
        spanClass: "",
        description: "Control live event with odds"
      },
       {
        id: "live-betting-control",
        title: "Betting Control",
        href: "/live-betting-control",
        Icon: FaDesktop,
        bgClass: "bg-customPredawn",
        spanClass: "",
        description: "Control live betting status"
      },
       {
        id: "user-control",
        title: "User Control",
        href: "/user-control",
        Icon: FaUsers,
        bgClass: "bg-customPredawn",
        spanClass: "",
        description: "Control user access"
      },
    ],
  },
  {
    id: "settings",
    title: "Settings",
    gridClass: "grid grid-cols-2 gap-1",
    items: [
      {
       id: "limit",
        title: "Limit",
        href: "/gambling-limit",
        Icon: FaBan,
        bgClass: "bg-customFontLightGreen",
        description: "Set limit amount"
      }
    ]
  },
   {
    id: "control",
    title: "Selection Control",
    gridClass: "grid grid-cols-2 gap-1",
    items: [
      {
       id: "league-select",
        title: "League Selection",
        href: "/league-selection",
        Icon: FaCheckCircle,
        bgClass: "bg-customFontLightGreen",
        description: "Choose event to betting"
      },
      {
       id: "buffer",
        title: "Buffer Zone",
        href: "/buffer-zone",
        Icon: FaBuffer,
        bgClass: "bg-customFontLightGreen",
        description: "Selected buffer zone"
      }
    ]
  },
];

export default menuSections;
